import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { takeUntil } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { SetCheckedNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';

@Component({
  selector: 'app-selected-nodes-panel',
  templateUrl: './selected-nodes-panel.component.html',
  styleUrls: ['./selected-nodes-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedNodesPanelComponent implements OnInit, OnDestroy {
  @Select(EngineNodesState.getCheckedNodes)
  checkedNodes$: Observable<ViewTreeNode[]>;

  count: number;

  private ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private graphService: BdGraphService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.checkedNodes$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((nodes) => {
        this.count = this.getLeaves(nodes).length;
        this.changeDetector.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleClearClick() {
    this.store.dispatch(new SetCheckedNodes([]));
  }

  getLeaves(nodes: ViewTreeNode[]): string[] {
    if (!nodes) {
      return [];
    }

    return this.graphService.getAllLeafDescendants(
      this.store.selectSnapshot(EngineState.getViewGraph), 
      nodes.map(node => node.id)
    );
  }
}
